/* tslint:disable */

declare var Object: any;
export interface SFAttendanceInterface {
  "id"?: number;
}

export class SFAttendance implements SFAttendanceInterface {
  "id": number;
  constructor(data?: SFAttendanceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttendance`.
   */
  public static getModelName() {
    return "SFAttendance";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttendance for dynamic purposes.
  **/
  public static factory(data: SFAttendanceInterface): SFAttendance{
    return new SFAttendance(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttendance',
      plural: 'SFAttendances',
      path: 'SFAttendances',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttendance.ts